(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["homepage-video"] && !Shopify.designMode) return;
  try {
    
    (function() {
      var section = document.getElementById('shopify-section-{{ section.id }}');
      if (!section) return;
      section.querySelectorAll('.homepage-video-poster[data-hide-on-play]').forEach(function(poster) {
        poster.addEventListener('click', function() {
          poster.setAttribute('data-hidden', '');
        }, { once: true });
      });
    })();
  
  } catch(e) { console.error(e); }
})();
})();
